/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Card types that ship as plastic and must be activated with their last4.
 *
 * Virtual cards (`vc`, `ec`, `vstc`, `vspc`) are usable on creation, so they
 * are excluded and rejected with 422. PPS activates every physical type
 * through one route, `/v3/payment-methods/cards/{card_type}/activate`, and
 * resolves the provider from its own records.
 */
export type PhysicalCardType =
  (typeof PhysicalCardType)[keyof typeof PhysicalCardType];

export const PhysicalCardType = {
  pc: "pc",
  pec: "pec",
  pstc: "pstc",
  pspc: "pspc",
} as const;
